import WidgetEventResourceModel from '../../generated/types/model/resource/WidgetEventResourceModel';

export default class WidgetEventResourceViewModel extends WidgetEventResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
